import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from 'react-apexcharts';

class FollowupsBySocialWorker extends Component {

  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
      },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      title: {
        text: 'Resumo Mensal dos Pedidos Encaminhados',
        align: 'center',
        margin: 40,
        style: {
          fontSize:  '18px',
          fontWeight:  'bold',
          color:  '#263238'
        },
      },
      xaxis: {
        categories: ["Taxa de Conversão (%)","Total", "", "Formulário Ajuda", "Linha de Apoio", "Facebook", "Email", "Formulário Equipamento"],
        labels: {
          formatter: function (val) {
            return val
          }
        }
      },
      yaxis: {
        title: {
          text: undefined
        },
        labels: {
          style: {fontSize:  '13px'}
          }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val 
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'left',
        offsetX: 40,
        fontSize:  '13px'  
      }
    },
  }

  render() {

    return (
      <div class="mb-4">
      {this.props.followUps && (
        <Chart 
          title={this.state.title}
          options={this.state.options} 
          series={ this.props.followUps.map(followUp => (
                    { name: followUp.name,
                      data: [((followUp.admitidos/followUp.total_count)*100).toFixed(2),
                            followUp.total_count, 
                            0,
                            followUp.backoffice, 
                            followUp.telemovel, 
                            followUp.facebook, 
                            followUp.email, 
                            followUp.form_equipamento] }
                  ))}
          type="bar" 
          width="100%"
          height="450"
        /> 
        )}
      </div> 
    );
  }
}
export default FollowupsBySocialWorker;
